import { createSlice } from '@reduxjs/toolkit';


import adesivo from '../img/adesivi_bar_saraceno.jpg'
import fiasconaro from '../img/biglietto_milena_fr.jpg'
import fiasconaro2 from '../img/biglietto_milena_re.jpg'
import leCoste from '../img/bigliettino_lecoste.jpg'
import vmCostruzioni from '../img/bigliettino-vm-costruzioni-fr.png';
import vmCostruzioni2 from '../img/bigliettino-vm-costruzioni-re.png';
import cosiStudio from '../img/bigliettino-cosi.png';
import estetista from '../img/biglietto_artego.png';
import logo from '../img/logo_giralda.png';
import onlus from '../img/logo_fondazione_panetti.jpg';
import comitato from '../img/logo_comitato_ornaro.png';
import prata from '../img/logo_prata.png';
import artego from '../img/logo_artego_salon.jpg'
import torre from '../img/logo_la_torre.png';
import caffeAngelo from '../img/logo_caffe_angelo.png';
import VolantinoPescheria from '../img/volantino_pescheria.jpg'
import VolantinoFarmacia from '../img/volantino_farmacia.jpg'
import VolantinoVivaticket from '../img/volantino_vivaticket_fr.jpg'
import VolantinoVivaticket2 from '../img/volantino_vivaticket_re.jpg'
import InfissoFr from '../img/volantino A5 infisso fr.jpg'
import InfissoRe from '../img/volantino A5 infisso re.jpg'
import VolantinoTao from '../img/volantino_tao_project.jpg'
import VolantinoOndaCafe from '../img/volantino_ondacafe_fr.jpg'
import VolantinoOndaCafe2 from '../img/volantino_ondacafe_re.jpg'
import LocandinaFlamenco from '../img/locandina-flamenco.png'
import LocandinaEventi from '../img/locandina_polentata.jpg'
import LocandinaMercatino from '../img/locandina-antiquariato.png'
import LocandinaCarnevale from '../img/locandina_carnevale.jpg'
import LocandinaMedievale from '../img/locandina_palio.jpg'
import ManifestoCapodanno from '../img/manifesto-capodanno.png'
import ManifestoOrnaro from '../img/manifesto_ornaro_basso.jpg'
import ManifestoMercato from '../img/manifesto-le-prata.png'
import ManifestoAlto from '../img/manifesto_ornaro_2019.jpg'
import DepliantEquoevento from '../img/equo_fr.jpg'
import DepliantEquoevento2 from '../img/equo_re.jpg'
import DepliantVeterinario from '../img/brochure_mancini.jpg'
import DepliantPaciotti from '../img/paciotti_fr.jpg'
import DepliantPaciotti2 from '../img/paciotti_re.jpg'
import DepliantLeCoste from '../img/depliant-le-coste-fr.png'
import DepliantLeCoste2 from '../img/depliant-le-coste-re.png'
import DepliantIpermercato from '../img/depliant-ipermercato-fr.png'
import DepliantIpermercato2 from '../img/deplliant-ipermercato-re.png'
import DepliantPim from '../img/depliant-pim-fr.png'
import DepliantPim2 from '../img/depliant-pim-re.png'
import RivistaOnlus from '../img/brochure_onlus.jpg'
import RivistaPolitica from '../img/libretto-comune.png'
import RivistaRicette from '../img/brochure-cucineros.png'
import RivistaSabina from '../img/rivista_sabina.jpg'
import fiches from '../img/fiches.jpg'
import AltrePortabicchieri from '../img/portabicchieri.png'
import AltreRoll from '../img/roll_up_vivaticket.png'
import AltreMagliette from '../img/prototipo_maglie_giocatori.jpg'
import AltreMagliette2 from '../img/maglia_portiere.jpg'
import AltreInsegna from '../img/insegna_regina.jpg'
import AltreOnlus from '../img/calendario_onlus.jpg'
import SitoAle from '../img/sito-ale.png'
import SitoFede from '../img/sito-fede.png'
import SitoHosteria from '../img/hosteria_dai_gemelli.png'
import Glicine from '../img/il_glicine.png'
import AppCalcio from '../img/sito-app-calcio.png'
import AppViaggi from '../img/sito-app-viaggi.png'
import BigliettinoPierFr from '../img/bigliettino-pier-fronte.jpg'
import BigliettinoPierRe from '../img/bigliettino-pier-re.jpg'
import BigliettoAle from '../img/bigliettino_ale.png'
import MenuFerragosto from '../img/menu_ferragosto_pier.jpg'
import Pier from '../img/menu_pier.jpg'
import Pier2 from '../img/menu_pier_2.jpg'
import StriscioneSonia from '../img/striscione_sonia.jpg'
import EtichetteSonia from '../img/etichette_sonia.jpg'
import LogoAle from '../img/logo_ale.png'
import FerramentaFr from '../img/serrature_fr.jpg'
import TrattoriaFr from '../img/biglietto_trattoria_fr.jpg';
import TrattoriaRe from '../img/biglietto_trattoria_re.jpg';
import EtichetteOnlus from '../img/sticker_onlus.jpg';
import Segnalibro from '../img/segnalibro_onlus.jpg'
import Tovagliette from '../img/tovagliette.jpg'


const CardDatiPortfolio = [
    {
    id: '1',
    sezione: 'Portfolio',
    categoria: 'Loghi',
    titolo: 'Logo Personale',
    dettagli: 'Il restyling è basato sull’idea di combinare le iniziali del mio nome e cognome. Il colore utilizzato è quello che amo di più e simboleggia la creatività. Per armonizzare il tutto gli ho dato “vita”...inserendo occhi e bocca, in modo da far trapelare simpatia, oltre a professionalità e serietà.',
    formato: '',
    supporto: '', 
    img: logo,
    img2: '',
    alt: 'logo Giralda', 
    },    
    {
    id: '2',
    sezione: 'Portfolio',
    categoria: 'Loghi',
    titolo: 'Logo Onlus Panetti',
    dettagli: 'Un progetto che mi rende particolarmente orgoglioso, dato che stiamo parlando del logo di una onlus che sostiene i bambini più poveri e aiuta loro a regalare “sorrisi”. I pattini alati, ahimè simboleggiano la passione della figlia della fondatrice del progetto, purtroppo scomparsa prematuramente.',
    formato: '',
    supporto: '', 
    img: onlus,
    img2: '',
    alt: 'logo Onlus', 
    },    
    {
    id: '3',
    sezione: 'Portfolio',
    categoria: 'Loghi',
    titolo: 'Logo comitato Ornaro Alto',
    dettagli: 'Dovendo trasmettere storia e cultura attraverso il logo e trovandomi pochi elementi caratterizzanti, ho puntato sull’idea di tornare indietro nel tempo, realizzando uno “stemma” che rappresenta la casata degli Orsini, proprietari del castello di Ornaro. Un idea azzeccata e super apprezzata.',
    formato: '',
    supporto: '', 
    img: comitato,
    img2: '',
    alt: 'logo comitato Ornaro', 
    },    
    {
    id: '4',
    sezione: 'Portfolio',
    categoria: 'Loghi',
    titolo: 'Logo associazione "Le Prata"',
    dettagli: 'Avevo molti dubbi pre-concept… realizzo uno schizzo a mano o punto su una silhouette? Ovviamente come potete ben vedere ho puntato sulla seconda. L’elemento vettoriale rappresenta il “Ponte Sambuco”, sito in Ornaro Basso. Il font (Montserrat) è servito a dare contrasto tra storico e moderno.',
    formato: '',
    supporto: '', 
    img: prata,
    img2: '',
    alt: 'logo ass.ne Le Prata', 
    },    
    {
    id: '5',
    sezione: 'Portfolio',
    categoria: 'Loghi',
    titolo: 'Logo Artego Salon "Parrucchieri"',
    dettagli: 'Un salone di parrucchiera, può diventare un saloon stile western? Certamente si, partendo dal logo! Grazie a un testo che segue un tracciato circolare in cui vengono “tagliate” alcune lettere, sono riuscito a far assimilare il logo dell’artego con quello appena creato, rendendolo una cosa sola.',
    formato: '',
    supporto: '', 
    img: artego,
    img2: '',
    alt: 'logo Artego Salon', 
    }, 
    {
    id: '6',
    sezione: 'Portfolio',
    categoria: 'Loghi',
    titolo: 'Logo bar-pizzeria "La Torre"',
    dettagli: 'Ho creato un logo che richiamasse la storicità del bar-pizzeria presente sotto la torre',
    formato: '',
    supporto: '', 
    img: torre,
    img2: '',
    alt: 'logo Pizzeria', 
    },    
    {
    id: '7',
    sezione: 'Portfolio',
    categoria: 'Loghi',
    titolo: 'Logo Dietista Alessandra Parisi',
    dettagli: "Il logo è stato concepito per comunicare l'equilibrio e la salute ottenuti seguendo una dieta che non punta alle privazioni.",
    formato: '',
    supporto: '', 
    img: LogoAle,
    img2: '',
    alt: 'logo Dietista Parisi', 
    },   
    {
    id: '55',
    sezione: 'Portfolio',
    categoria: 'Loghi',
    titolo: 'Logo Bar Angelo',
    dettagli: "Creazione del logo creando una shilouette della bottiglia di vino e del caffè nel lettering.",
    formato: '',
    supporto: '', 
    img: caffeAngelo,
    img2: '',
    alt: 'logo Bar Angelo', 
    },   
    {
    id: '8',
    sezione: 'Portfolio',
    categoria: 'Bigliettini',
    titolo: 'Adesivo in carta',
    dettagli: 'Bar Saraceno',
    formato: 'A6 (10,5 x 14,8 cm)',
    supporto: 'Carta adesiva 60 gr', 
    img: adesivo,
    img2: '',
    alt: 'adesivo A6', 
    },
    {
    id: '9',
    sezione: 'Portfolio',
    categoria: 'Bigliettini',
    titolo: 'Bigliettino classico',
    dettagli: 'Fiasconaro',
    formato: '8,5 x 5,5 cm',
    supporto: 'Carta patinata lucida 350 gr', 
    img: fiasconaro,
    img2: fiasconaro2,
    alt: 'bigliettino fiasconaro', 
    },
    {
    id: '10',
    sezione: 'Portfolio',
    categoria: 'Bigliettini',
    titolo: 'Bigliettino pieghevole',
    dettagli: 'VM Ristrutturazioni',
    formato: 'aperto: (17 x 8,5 cm)',
    supporto: 'Carta patinata opaca 350 gr - 1 piega | 2 ante', 
    img: vmCostruzioni,
    img2: vmCostruzioni2,
    alt: 'bigliettino VM Ristrutturazioni', 
    },
    {
    id: '11',
    sezione: 'Portfolio',
    categoria: 'Bigliettini',
    titolo: 'Bigliettino classico',
    dettagli: 'Ristorante "Le Coste"',
    formato: '5,5 x 8,5 cm',
    supporto: 'Carta patinata lucida 350 gr', 
    img: leCoste,
    img2: '',
    alt: 'bigliettino ristorante "Le Coste"', 
    },
    {
    id: '12',
    sezione: 'Portfolio',
    categoria: 'Bigliettini',
    titolo: 'Bigliettino quadrato',
    dettagli: 'Così Studio',
    formato: '5,5 x 5,5 cm',
    supporto: 'Carta usomano 350 gr', 
    img: cosiStudio,
    img2: '',
    alt: 'bigliettino Così Studio', 
    },
    {
    id: '13',
    sezione: 'Portfolio',
    categoria: 'Bigliettini',
    titolo: 'Bigliettino pieghevole',
    dettagli: 'Estetista',
    formato: '11 x 5,5 cm',
    supporto: 'Carta patinata lucida 400 gr - 1 piega | 2 ante', 
    img: estetista,
    img2: '',
    alt: 'adesivo A6', 
    },
    {id: '14',
    sezione: 'Portfolio',
    categoria: 'Bigliettini',
    titolo: 'Bigliettino Classico',
    dettagli: 'Dietista Alessandra Parisi',
    formato: '8,5 x 5,5 cm',
    supporto: 'Carta patinata opaca 350 gr', 
    img: BigliettoAle,
    img2: '',
    alt: 'bigliettino dietista Parisi', 
    },
    {id: '54',
    sezione: 'Portfolio',
    categoria: 'Bigliettini',
    titolo: 'Bigliettino Classico',
    dettagli: "L'Incontro - Ristorantino di pesce",
    formato: '8,5 x 5,5 cm',
    supporto: 'Carta patinata opaca 350 gr', 
    img: BigliettinoPierFr,
    img2: BigliettinoPierRe,
    alt: "bigliettino L'Incontro - Ristorantino di pesce", 
    },
    {id: '56',
    sezione: 'Portfolio',
    categoria: 'Bigliettini',
    titolo: 'Bigliettino Classico',
    dettagli: "Ferramenta - C.S. Tiburtina",
    formato: '8,5 x 5,5 cm',
    supporto: 'Carta patinata opaca 350 gr', 
    img: FerramentaFr,
    img2: '',
    alt: "Ferramenta - C.S. Tiburtina",
    },
    {id: '57',
    sezione: 'Portfolio',
    categoria: 'Bigliettini',
    titolo: 'Bigliettino Classico',
    dettagli: "Trattoria 'Da Maria'",
    formato: '8,5 x 5,5 cm',
    supporto: 'Carta patinata opaca 350 gr', 
    img: TrattoriaFr,
    img2: TrattoriaRe,
    alt: "Trattoria 'Da Maria",
    },
    {
    id: '15',
    sezione: 'Portfolio',
    categoria: 'Volantini',
    titolo: 'Volantino',
    dettagli: 'Fresco & Fritto',
    formato: '14,8 x 21 cm',
    supporto: 'Carta patinata opaca 130 gr', 
    img: VolantinoPescheria,
    img2: '',
    alt: 'volantino pescheria', 
    },
    {
    id: '16',
    sezione: 'Portfolio',
    categoria: 'Volantini',
    titolo: 'Volantino',
    dettagli: 'Farmacia Giovannetti',
    formato: '14,8 x 21 cm',
    supporto: 'Carta patinata opaca 130 gr', 
    img: VolantinoFarmacia,
    img2: '',
    alt: 'volantino Farmacia', 
    },
    {
    id: '17',
    sezione: 'Portfolio',
    categoria: 'Volantini',
    titolo: 'Volantino',
    dettagli: 'Vivaticket',
    formato: '14,8 x 21 cm',
    supporto: 'Carta patinata opaca 130 gr', 
    img: VolantinoVivaticket,
    img2: VolantinoVivaticket2,
    alt: 'volantino Vivaticket', 
    },
    {
    id: '18',
    sezione: 'Portfolio',
    categoria: 'Volantini',
    titolo: 'Volantino',
    dettagli: "L'Infisso",
    formato: '14,8 x 21 cm',
    supporto: 'Carta patinata opaca 130 gr', 
    img: InfissoFr,
    img2: InfissoRe,
    alt: "volantino l'Infisso'", 
    },
    {
    id: '19',
    sezione: 'Portfolio',
    categoria: 'Volantini',
    titolo: 'Volantino',
    dettagli: 'Tao Project',
    formato: '14,8 x 21 cm',
    supporto: 'Carta patinata opaca 130 gr', 
    img: VolantinoTao,
    img2: '',
    alt: 'volantino Tao Project', 
    },
    {
    id: '20',
    sezione: 'Portfolio',
    categoria: 'Volantini',
    titolo: 'Volantino',
    dettagli: 'OndaCafè restaurant',
    formato: '14,8 x 21 cm',
    supporto: 'Carta patinata opaca 130 gr', 
    img: VolantinoOndaCafe,
    img2: VolantinoOndaCafe2,
    alt: 'volantino Ondacafè', 
    },
    {
    id: '21',
    sezione: 'Portfolio',
    categoria: 'Locandine',
    titolo: 'Locandina',
    dettagli: 'Serata Flamenco',
    formato: '29,7 x 42 cm',
    supporto: 'Carta patinata lucida 130 gr', 
    img: LocandinaFlamenco,
    img2: '',
    alt: 'locandina flamenco', 
    },
    {
    id: '22',
    sezione: 'Portfolio',
    categoria: 'Locandine',
    titolo: 'Locandina',
    dettagli: 'Polentata in piazza',
    formato: '29,7 x 42 cm',
    supporto: 'Carta patinata lucida 130 gr', 
    img: LocandinaEventi,
    img2: '',
    alt: 'Polentata in piazza', 
    },
    {
    id: '23',
    sezione: 'Portfolio',
    categoria: 'Locandine',
    titolo: 'Locandina',
    dettagli: "Mercatino dell'usato",
    formato: '29,7 x 42 cm',
    supporto: 'Carta patinata lucida 130 gr', 
    img: LocandinaMercatino,
    img2: '',
    alt: "locandina mercatino dell'usato", 
    },
    {
    id: '24',
    sezione: 'Portfolio',
    categoria: 'Locandine',
    titolo: 'Locandina',
    dettagli: 'Festa in maschera',
    formato: '29,7 x 42 cm',
    supporto: 'Carta patinata lucida 130 gr', 
    img: LocandinaCarnevale,
    img2: '',
    alt: 'locandina festa in maschera', 
    },
    {
    id: '25',
    sezione: 'Portfolio',
    categoria: 'Locandine',
    titolo: 'Locandina',
    dettagli: 'Palio Medievale',
    formato: '29,7 x 42 cm',
    supporto: 'Carta patinata lucida 130 gr', 
    img: LocandinaMedievale,
    img2: '',
    alt: 'locandina palio medievale', 
    },
    {
    id: '26',
    sezione: 'Portfolio',
    categoria: 'Locandine',
    titolo: 'Locandina',
    dettagli: 'Menù di Ferragosto',
    formato: '29,7 x 42 cm',
    supporto: 'Carta patinata lucida 130 gr', 
    img: MenuFerragosto,
    img2: '',
    alt: 'locandina menù ferragosto', 
    },
    {
    id: '27',
    sezione: 'Portfolio',
    categoria: 'Manifesti',
    titolo: 'Manifesto',
    dettagli: 'Capodanno',
    formato: '50 x 70 cm',
    supporto: 'Carta white back 130 gr', 
    img: ManifestoCapodanno,
    img2: '',
    alt: 'manifesto capodanno', 
    },
    {
    id: '28',
    sezione: 'Portfolio',
    categoria: 'Manifesti',
    titolo: 'Manifesto',
    dettagli: 'Festeggiamenti Ornaro',
    formato: '70 x 100 cm',
    supporto: 'Carta blue back 130 gr', 
    img: ManifestoOrnaro,
    img2: '',
    alt: 'manifesto Ornaro', 
    },
    {
    id: '29',
    sezione: 'Portfolio',
    categoria: 'Manifesti',
    titolo: 'Manifesto',
    dettagli: 'Mercato delle stagioni',
    formato: '70 x 100 cm',
    supporto: 'Carta blue back 130 gr', 
    img: ManifestoMercato,
    img2: '',
    alt: 'manifesto Mercato', 
    },
    {
    id: '30',
    sezione: 'Portfolio',
    categoria: 'Manifesti',
    titolo: 'Manifesto',
    dettagli: 'Festeggiamenti Ornaro',
    formato: '100 x 70 cm',
    supporto: 'Carta blue back 130 gr',
    img: ManifestoAlto,
    img2: '',
    alt: 'Manifesto Ornaro', 
    },
    {
    id: '31',
    sezione: 'Portfolio',
    categoria: 'Depliant',
    titolo: 'Depliant',
    dettagli: 'Equoevento',
    formato: 'A4 (chiuso 10 x 21 cm) - 3 ante | 2 linee di piega',
    supporto: 'Carta patatina lucida 130 gr',
    img: DepliantEquoevento,
    img2: DepliantEquoevento2,
    alt: 'Depliant Equoevento', 
    },
    {
    id: '32',
    sezione: 'Portfolio',
    categoria: 'Depliant',
    titolo: 'Depliant',
    dettagli: 'Veterinario Mancini',
    formato: 'A4 (chiuso 14,8 x 21 cm) - 2 ante | 1 linea di piega',
    supporto: 'Carta patatina lucida 130 gr',
    img: DepliantVeterinario,
    img2: '',
    alt: 'Depliant Veterinario', 
    },
    {
    id: '33',
    sezione: 'Portfolio',
    categoria: 'Depliant',
    titolo: 'Depliant',
    dettagli: 'Pizzeria Paciotti',
    formato: 'A4 (chiuso 10 x 21 cm) - 3 ante | 2 linee di piega',
    supporto: 'Carta patatina lucida 130 gr',
    img: DepliantPaciotti,
    img2: DepliantPaciotti2,
    alt: 'Depliant Pizzeria', 
    },
    {
    id: '34',
    sezione: 'Portfolio',
    categoria: 'Depliant',
    titolo: 'Menù',
    dettagli: 'Ristorante "Le Coste"',
    formato: '30 x 20 cm (chiuso 15 x 20 cm) - 2 ante | 1 linea di piega',
    supporto: 'Cartoncino usomano 300 gr',
    img: DepliantLeCoste,
    img2: DepliantLeCoste2,
    alt: 'Depliant Ristorante', 
    },
    {
    id: '35',
    sezione: 'Portfolio',
    categoria: 'Depliant',
    titolo: 'Volantone',
    dettagli: 'Ipermercato',
    formato: 'A2 (chiuso 21 x 29,7 cm) - piega a croce',
    supporto: 'Carta patatina lucida 130 gr',
    img: DepliantIpermercato,
    img2: DepliantIpermercato2,
    alt: 'Volantone Ipermercato', 
    },
    {
    id: '36',
    sezione: 'Portfolio',
    categoria: 'Depliant',
    titolo: 'Depliant',
    dettagli: 'Pim - Idealmarket',
    formato: 'A3 (chiuso 21 x 29,7 cm)',
    supporto: 'Carta patatina opaca 130 gr',
    img: DepliantPim,
    img2: DepliantPim2,
    alt: 'Depliant Pim', 
    },
    {
    id: '37',
    sezione: 'Portfolio',
    categoria: 'Brochure - Riviste',
    titolo: 'Brochure',
    dettagli: 'Onlus Panetti',
    formato: 'A4 (21 x 29,7 cm)',
    supporto: 'Carta usomano 300 gr - cordonato',
    img: RivistaOnlus,
    img2: '',
    alt: 'Brochure Onlus', 
    },
    {
    id: '38',
    sezione: 'Portfolio',
    categoria: 'Brochure - Riviste',
    titolo: 'Libretto Politico',
    dettagli: 'Partito "Progetto Comune',
    formato: 'A5 (14,8 x 21 cm)',
    supporto: 'Carta patinata lucida 130 gr',
    img: RivistaPolitica,
    img2: '',
    alt: 'Libretto Politico', 
    },
    {
    id: '39',
    sezione: 'Portfolio',
    categoria: 'Brochure - Riviste',
    titolo: 'Libro',
    dettagli: 'Ricette di cucina',
    formato: '21 x 21 cm',
    supporto: 'Carta patinata opaca 170 gr',
    img: RivistaRicette,
    img2: '',
    alt: 'Libro di cucina', 
    },
    {
    id: '40',
    sezione: 'Portfolio',
    categoria: 'Brochure - Riviste',
    titolo: 'Rivista',
    dettagli: 'La Sabina in vetrina',
    formato: 'A5 (14,8 x 21 cm)',
    supporto: 'Carta patinata opaca 130 gr',
    img: RivistaSabina,
    img2: '',
    alt: 'Rivista', 
    },
    {
    id: '41',
    sezione: 'Portfolio',
    categoria: 'Altre lavorazioni',
    titolo: 'Fiches',
    dettagli: 'Space Elettrodomestici',
    formato: 'A6 (10,5 x 14,8 cm)',
    supporto: 'Carta usomano 100 gr',
    img: fiches,
    img2: '',
    alt: 'fiches preventivi', 
    },
    {
    id: '42',
    sezione: 'Portfolio',
    categoria: 'Altre lavorazioni',
    titolo: 'Portabicchieri',
    dettagli: 'Serata degustazione vini',
    formato: '17 x 23 x 10 cm',
    supporto: 'Tessuto non tessuto, TNT - 80 g/m2',
    img: AltrePortabicchieri,
    img2: '',
    alt: 'portabicchieri degustazione', 
    },
    {
    id: '43',
    sezione: 'Portfolio',
    categoria: 'Altre lavorazioni',
    titolo: 'Roll-up',
    dettagli: 'VivaTicket',
    formato: '80 x 200 cm',
    supporto: 'Banner calandrato 450 gr',
    img: AltreRoll,
    img2: '',
    alt: 'roll-up Vivaticket', 
    },
    {
    id: '44',
    sezione: 'Portfolio',
    categoria: 'Altre lavorazioni',
    titolo: 'Magliette personalizzate',
    dettagli: 'Torneo calcetto',
    formato: 'misure varie',
    supporto: 'cotone 100%',
    img: AltreMagliette,
    img2: AltreMagliette2,
    alt: 'magliette torneo', 
    },
    {
    id: '45',
    sezione: 'Portfolio',
    categoria: 'Altre lavorazioni',
    titolo: 'Insegna',
    dettagli: 'Ristorante Regina',
    formato: '300 x 200 cm',
    supporto: 'forex 10 mm con protezione lucida',
    img: AltreInsegna,
    img2: '',
    alt: 'insegina ristorante', 
    },
    {
    id: '46',
    sezione: 'Portfolio',
    categoria: 'Altre lavorazioni',
    titolo: 'Calendario',
    dettagli: 'Onlus Panetti',
    formato: '29 x 47 cm (olandese)',
    supporto: 'applicazione adesivo vinilico 100 gr',
    img: AltreOnlus,
    img2: '',
    alt: 'calendario olandese', 
    },
    {
    id: '47',
    sezione: 'Portfolio',
    categoria: 'Altre lavorazioni',
    titolo: 'Menù plastificato',
    dettagli: "L'incontro - Ristorantino di pesce",
    formato: '21 x 29,7 cm',
    supporto: 'carta patinata opaca 170 gr',
    img: Pier,
    img2: Pier2,
    alt: "Menù L'incontro - Ristorantino di pesce", 
    },
    {
    id: '48',
    sezione: 'Portfolio',
    categoria: 'Altre lavorazioni',
    titolo: 'Striscione',
    dettagli: "L'Orchidea di Sonia Cerboni",
    formato: '200 x 80 cm',
    supporto: 'Pvc 500 g/m² con occhielli e rinforzo perimetrale',
    img: StriscioneSonia,
    img2: '',
    alt: 'striscione pvc', 
    },
    {
    id: '49',
    sezione: 'Portfolio',
    categoria: 'Altre lavorazioni',
    titolo: 'Etichette in bobina',
    dettagli: "L'Orchidea di Sonia Cerboni",
    formato: '4 x 3 cm',
    supporto: 'carta adesiva bianca naturale',
    img: EtichetteSonia,
    img2: '',
    alt: 'etichette adesive', 
    },
    {
    id: '58',
    sezione: 'Portfolio',
    categoria: 'Altre lavorazioni',
    titolo: 'Sticker adesivi',
    dettagli: "Fondazione Panetti",
    formato: '5 x 5 cm',
    supporto: 'pvc adesivo',
    img: EtichetteOnlus,
    img2: '',
    alt: 'etichette adesive', 
    },
    {
    id: '59',
    sezione: 'Portfolio',
    categoria: 'Altre lavorazioni',
    titolo: 'Segnalibro',
    dettagli: "Fondazione Panetti",
    formato: '5,5 x 21 cm',
    supporto: 'carta turner 350 gr',
    img: Segnalibro,
    img2: '',
    alt: 'segnalibro onlus', 
    },
    {
    id: '60',
    sezione: 'Portfolio',
    categoria: 'Altre lavorazioni',
    titolo: 'Tovagliette',
    dettagli: "Bar-Pizzeria L'Incontro",
    formato: '42 x 29,7 cm',
    supporto: 'carta usomano 90 gr',
    img: Tovagliette,
    img2: '',
    alt: 'tovagliette ristorante', 
    },
    {
    id: '61',
    sezione: 'Portfolio',
    categoria: 'Siti e Web App',
    titolo: 'Sito web',
    dettagli: 'Hosteria dai Gemelli',
    formato: '',
    supporto: '',
    img: SitoHosteria,
    img2: '',
    alt: 'Sito web Hosteria dai Gemelli',
    link: 'https://www.hosteriadaigemelli.it/' 
    },
    {
    id: '62',
    sezione: 'Portfolio',
    categoria: 'Siti e Web App',
    titolo: 'Sito web',
    dettagli: 'Il Glicine Bar-Bistrot',
    formato: '',
    supporto: '',
    img: Glicine,
    img2: '',
    alt: 'Sito web Il Glicine Bar-Bistrot',
    link: 'https://www.ilglicinebarbistrot.it/' 
    },
    {
    id: '50',
    sezione: 'Portfolio',
    categoria: 'Siti e Web App',
    titolo: 'Sito web',
    dettagli: 'Dietista Parisi',
    formato: '',
    supporto: '',
    img: SitoAle,
    img2: '',
    alt: 'sito web Parisi',
    link: 'http://www.parisinutrizionista.altervista.org/index.html' 
    },
    {
    id: '51',
    sezione: 'Portfolio',
    categoria: 'Siti e Web App',
    titolo: 'Sito web',
    dettagli: 'Trattoria "La Quercia"',
    formato: '',
    supporto: '',
    img: SitoFede,
    img2: '',
    alt: 'sito web Trattoria',
    link: 'https://www.trattorialaquercia.it/index.html' 
    },
    {
    id: '52',
    sezione: 'Portfolio',
    categoria: 'Siti e Web App',
    titolo: 'Web App',
    dettagli: 'Agenzia viaggi "Sognando Viaggiando"',
    formato: '',
    supporto: '',
    img: AppViaggi,
    img2: '',
    alt: 'Web app agenzia viaggi',
    link: 'https://app-viaggi-88322.web.app/' 
    },
    {
    id: '53',
    sezione: 'Portfolio',
    categoria: 'Siti e Web App',
    titolo: 'Web App',
    dettagli: 'FootbalLife',
    formato: '',
    supporto: '',
    img: AppCalcio,
    img2: '',
    alt: 'Web app FootbalLife',
    link: 'https://app-footballife.web.app/' 
    },
    ]


const DatiPortfolio = createSlice({

    name: 'DatiPortfolio',
    initialState:{
    value: CardDatiPortfolio
    },


    // reducers:{

        ChangePayload: (state, payload) => {
         state.value = payload    
        },

    //     changePageToggle: (state) => {
    //     state.value = false   
    //     }
    // }

});


export const {ChangePayload} = DatiPortfolio.actions

export default DatiPortfolio.reducer